/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {suggestedArticles} from '../api'

export const useMutationSuggestedArticles = createReactQueryMutationHook('suggestedArticles', suggestedArticles)
